<div id="about-us">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">Mission & Vision</h4>
                    <div class="card-body text-justify">
                        <h5>Vision</h5>
                        <hr class="pb-1 opacity-100 rounded" style="width: 60px;">
                        <p class="text-justify inner-lead">To be a temple of learning where the devotees are nurtured to worship knowledge and harness it for the good of mankind.</p>
                        <h5>Mission</h5>
                        <hr class="pb-1 opacity-100 rounded" style="width: 80px;">
                        <ul>
                            <li>
                                <p class="inner-lead">To provide quality education to the children with minimum financial burden on the parents.</p>
                            </li>
                            <li>
                                <p class="inner-lead">To ensure physical, mental and moral growth of the students and create in them a zest for learning. 
                                </p>
                            </li>
                            <li>
                                <p class="inner-lead">To judiciously arouse their aesthetic sense and inculcate habits of personal as well as social hygiene for their overall well-being. </p>
                            </li>
                            <li>
                                <p class="inner-lead">To engage the students in cooperative endeavors and develop in them team spirit and a service mentality.</p>
                            </li>
                            <li>
                                <p class="inner-lead">To channelize youthful energies towards creativity and self-actualization.</p>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>